//import { getStock } from "./cols/stock.service";
import { getEmpresas } from "./cols/empresas.service";
import { getSectores } from "./cols/sectores.service";
import { getEnTaller } from "./enTaller";

const cache = {};
const buildMap = (arr) =>
  Object.fromEntries(arr.map(i => [String(i.id), i]));
const loaders = {
  //stock: getStock,
  empresas: getEmpresas,
  sectores: getSectores,
  /* Las estadías abiertas del taller, para que el padrón pueda mostrar
   * «Condicional» sin escribirlo en ningún lado (#114). Vive acá y no en cada
   * pantalla por la misma razón que `empresas`: `enriquecer` corre por fila y
   * no puede salir a la base por cada una. */
  enTaller: getEnTaller,
};
/* Una sola vez. Ahora esto corre en la pantalla de carga Y el armazon lo
 * vuelve a llamar al montar; sin esta guarda, entrar significaria bajar las
 * mismas tablas dos veces seguidas. */
let iniciado = null;

export const initCache = async () => {
  if (iniciado) return iniciado;
  iniciado = cargarTodo();
  return iniciado;
};

const cargarTodo = async () => {

  console.log("[Cache] Inicializando...");

  const keys = Object.keys(loaders);

  await Promise.all(
    keys.map(async (key) => {

      const data = await loaders[key]();

      cache[key] = {
        data,
        map: buildMap(data),
        updatedAt: Date.now(),
      };

      console.log(
        `[Cache] ${key} cargado (${data.length})`
      );
    })
  );

  console.log("[Cache] listo ✔");

};

export const cacheStore = cache;

export const refreshCache = async (key) => {

  if (!loaders[key]) return;

  console.log(`[Cache] Refresh ${key}`);

  const data = await loaders[key]();

  cache[key] = {
    data,
    map: buildMap(data),
    updatedAt: Date.now(),
  };

  return cache[key];
};